<template>
  <div class="asc-metrics-template">
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="3">
        <div class="asc-metrics-column">
          <asc-dynamic-counter-wrapper
            :items="dynamicCounterData"
            :internal-user="internalUser"
          />
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="9">
        <div class="asc-metrics-column--margin">
          <asc-bar-chart-wrapper
            :values="issueCountData.values"
            :title="issueCountData.title"
            :series-name="issueCountData.seriesName"
            :category-name="issueCountData.categoryName"
          ></asc-bar-chart-wrapper>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  AscDynamicCounterWrapper,
  AscBarChartWrapper,
} from '@/components/organisms'

export default {
  name: 'AscMetricsTemplate',

  components: {
    AscDynamicCounterWrapper,
    AscBarChartWrapper,
  },

  props: {
    dynamicCounterData: {
      type: Array,
      default: () => [],
    },
    issueCountData: {
      type: Object,
      default: () => {},
    },
    internalUser: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-metrics-template {
  margin-bottom: 16px;

  .asc-metrics-column {
    height: 100%;

    &--margin {
      margin-left: 16px;
    }
  }
}

@media (max-width: 960px) {
  .asc-metrics-template {
    .asc-metrics-column {
      &--margin {
        margin: 16px 0;
      }
    }
  }
}
</style>
